import React from 'react';
import PropTypes from 'prop-types';
import { StyledProgressCircle } from './style';

const ProgressCircle = ({
  progress = 0,
  size = 58,
  trackWidth = 8,
  progressWidth = 8,
  trackColor = '#D1D1D1',
  progressColor = '#003366',
}) => {
  const cappedProgress = Math.min(Math.max(progress, 0), 100);

  //position
  const center = size / 2;
  const radius = center - Math.max(trackWidth, progressWidth) / 2;

  //progress
  const dashArray = 2 * Math.PI * radius;
  const dashOffset = dashArray * ((100 - cappedProgress) / 100);

  return (
    <StyledProgressCircle
      role="progressbar"
      aria-valuenow={cappedProgress}
      aria-valuemax={100}
    >
      <svg className="circle" width={size} height={size}>
        <circle
          className="circle__track"
          cx={center}
          cy={center}
          fill="transparent"
          r={radius}
          stroke={trackColor}
          strokeWidth={trackWidth}
        />
        <circle
          className={`circle__progress size${size}`}
          cx={center}
          cy={center}
          fill="transparent"
          r={radius}
          stroke={progressColor}
          strokeWidth={progressWidth}
          strokeDasharray={dashArray}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
        />
      </svg>
      <p>
        <span className="progress__value">{cappedProgress}</span>
        <span className="progress__symbol">%</span>
      </p>
    </StyledProgressCircle>
  );
};

ProgressCircle.propTypes = {
  progress: PropTypes.number,
  size: PropTypes.number,
  trackWidth: PropTypes.number,
  progressWidth: PropTypes.number,
  trackColor: PropTypes.string,
  progressColor: PropTypes.string,
};

export default ProgressCircle;
